var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_5925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.75 0H6.25C2.79875 0 0 2.79875 0 6.25V13.75C0 17.2013 2.79875 20 6.25 20H13.75C17.2013 20 20 17.2013 20 13.75V6.25C20 2.79875 17.2013 0 13.75 0ZM18.125 13.75C18.125 16.1625 16.1625 18.125 13.75 18.125H6.25C3.8375 18.125 1.875 16.1625 1.875 13.75V6.25C1.875 3.8375 3.8375 1.875 6.25 1.875H13.75C16.1625 1.875 18.125 3.8375 18.125 6.25V13.75Z",
    fill: "url(#paint0_linear_245_5925)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 5C7.23875 5 5 7.23875 5 10C5 12.7613 7.23875 15 10 15C12.7613 15 15 12.7613 15 10C15 7.23875 12.7613 5 10 5ZM10 13.125C8.2775 13.125 6.875 11.7225 6.875 10C6.875 8.27625 8.2775 6.875 10 6.875C11.7225 6.875 13.125 8.27625 13.125 10C13.125 11.7225 11.7225 13.125 10 13.125Z",
    fill: "url(#paint1_linear_245_5925)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3772 5.29148C15.7451 5.29148 16.0434 4.99319 16.0434 4.62523C16.0434 4.25727 15.7451 3.95898 15.3772 3.95898C15.0092 3.95898 14.7109 4.25727 14.7109 4.62523C14.7109 4.99319 15.0092 5.29148 15.3772 5.29148Z",
    fill: "url(#paint2_linear_245_5925)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_245_5925",
    x1: 1.83081,
    y1: 18.1693,
    x2: 18.1692,
    y2: 1.83069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#F44336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9C27B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_245_5925",
    x1: 6.46456,
    y1: 13.5354,
    x2: 13.5354,
    y2: 6.46456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#F44336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9C27B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_245_5925",
    x1: 14.9061,
    y1: 5.09642,
    x2: 15.8482,
    y2: 4.15416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#F44336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9C27B0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_5925"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstra);
export default __webpack_public_path__ + "static/media/instra.a83c3e5601895585da7af5a1f5a6a704.svg";
export { ForwardRef as ReactComponent };